import { PluginCard, PluginCardCommonProps } from '../../../plugins-tab/PluginCard';
import { PluginDataManagementSvg } from '../../icons';
import { dataManagementTexts } from './texts';

export const DataManagementPluginCard = (props: PluginCardCommonProps) => {
  return (
    <PluginCard
      svgIcon={<PluginDataManagementSvg />}
      title={dataManagementTexts.title}
      description={dataManagementTexts.description}
      {...props}
    />
  );
};
